import http from "@/http";

// ### 获取统计数据数据
//https://zs.xzu.ink/api/census/all
export const getCensusAll = {
  p: "/api/census/all",
  r: data => {
    return http({
      url: "/api/census/all",
      method: "get",
      data
    });
  }
};
